<template>
  <div class="container">
    <div class="video-wp">
      <div class="title-wp">
        <p class="title">【{{ info[id].userName }}】{{ info[id].title }}</p>
        <div class="info">
          <span class="user">
            <img :src="info[id].avatar">
            <span>{{ info[id].userName }}</span>
          </span>
          <span class="live">直播</span>
          <span class="people">观看人数：{{ info[id].peopleCount }}</span>
        </div>
      </div>
      <video :src="info[id].videoSrc" controls height="600" class="video" autoplay loop>
      </video>
    </div>

    <div class="comment-wp">
      <div class="title">
        讨论区
      </div>
      <div class="comment">
        <div class="comment-item">
          <img :src="info[id].avatar">
          <div class="message-wp">
            <span class="name">{{ info[id].userName }}</span>
            <div class="message">
              欢迎来到我的直播间
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: '',
      info: {
        1: {
          avatar: 'https://pic.lehe.com/pic/_o/53/49/357c55c8d70ecfe495860a793f58_828_828.cz.jpg_b64017ef_s1_q1_90_750_4000.jpg',
          userName: '剑齿丶',
          title: '晴天 - 周杰倫 "吉他獨奏" (Steven Law)',
          peopleCount: '2321',
          videoSrc: 'http://image.lehe.com/videoplayback%20(2).mp4'
        },
        2: {
          avatar: 'https://pic.lehe.com/pic/_o/a1/20/9b30a02709c2b0772f12a295f108_706_706.cz.jpg_0715d281_s1_q1_90_750_4000.jpg',
          userName: 'MBear',
          title: '周杰伦 晴天 吉他弹唱',
          peopleCount: '3672',
          videoSrc: 'http://image.lehe.com/videoplayback%20(1).mp4'
        },
        3: {
          avatar: 'https://pic.lehe.com/pic/_o/4d/4d/6828932212e8decaddc510fe3f10_548_548.cz.jpg_b03b6b0a_s1_q1_90_750_4000.jpg',
          userName: '躺着吃肉都会胖',
          title: '《丘比特之箭》独奏民谣吉他-刘Ja（Jaco Liu）原创',
          peopleCount: '5632',
          videoSrc: 'http://image.lehe.com/videoplayback.mp4'
        }
      }
    }
  },
  mounted() {
    const { params: { id } } = this.$route
    this.id = id
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px 180px;

  .video-wp {
    flex: 1;

    .title-wp {
      margin: 10px 0;
      .title {
        font-weight: bold;
        font-size: 18px;
        margin: 10px 0;
      }

      .info {
        display: flex;
        align-items: center;

        .user {
          display: flex;
          align-items: center;
          margin-right: 8px;

          & > img {
            width: 30px;
            border: solid 1px #cccccc;
            border-radius: 50%;
          }
          & > span {
            font-size: 12px;
            font-weight: bold;
            margin-left: 4px;
          }
        }

        .live {
          background-color: orangered;
          padding: 4px 6px;
          border-radius: 4px;
          color: white;
          font-size: 12px;
        }

        .people {
          font-size: 14px;
          margin-left: 10px;
        }
      }

    }

    .video {
      width: 100%;
      background-color: black;
    }
  }


  .comment-wp {
    width: 300px;
    height: 600px;
    margin-top:78px;
    border: solid 1px #d9d9d9;
    box-sizing: border-box;
    padding: 0 6px;

    .title {
      font-size: 14px;
      font-weight: bold;
      padding: 10px 0 6px;
      border-bottom: solid 1px #f1f1f1;
    }

    .comment {
      padding: 10px 0;

      .comment-item {
        display: flex;
        align-items: flex-start;
        background-color: rgba(65, 182, 230, .3);
        border: solid 1px rgba(65, 182, 230, .8);
        padding: 10px 8px;
        border-radius: 8px;

        & > img {
          width: 20px;
          border-radius: 50%;
        }
        .message-wp {
          font-size: 12px;
          margin-left: 4px;
          .name {
            font-weight: bold;
          }
          .message {
            margin-top: 6px;
          }
        }
      }
    }
  }
}

</style>
